import ApplicationController from '../../application_controller.js';
import { Janus } from 'janus-gateway';
// Audio Connection Functions

export default class AudioConnectionController extends ApplicationController {
    // Attach janus SIP plugin for connecting audio to Asterisk
    attachSIP() {
        let self = this;
        let janus = window.janus;
    
        return new Promise((resolve, reject) => {
            janus.attach({
                plugin: "janus.plugin.sip",
                success: (pluginHandle) => {
                    self.pluginHandle = pluginHandle;
                    resolve(pluginHandle);
                },
                error: (error) => {
                    reject(error);
                },
                iceState: (state) => {
                    Janus.log("Audio iceState", state);
                    if (state == "disconnected") {
                        self.pluginHandle.createOffer({ iceRestart: true });
                    }
                    if (state == "failed") {
                        console.error("Audio ICE connection state changed to failed");
                    }
                },
                mediaState: (medium, on) => {
                    Janus.log("Janus mediaState", medium, on);
                    if (medium == "audio" && on == false) {
                        self.pluginHandle.createOffer({ iceRestart: true });
                    }
                },
                webrtcState: (on) => {
                    if (on == true) {
                        console.debug("Audio peer connection connected successfully");
                    } else {
                        console.debug("Audio peer connection disconnected");
                    }
                },
                slowLink: (downlink, lost, mid) => {
                    // ...
                },
                onmessage: (msg, jsep) => {
                    self.handleMessage(self.pluginHandle, msg, jsep);
                },
                onlocaltrack: (stream) => {
                    Janus.log("Janus localstream track", stream);
                },
                onremotetrack: (track) => {
                    // Attaches the audio stream to the audio element on the page
                    var audioPlayer = document.getElementById('audioplayer');
                    var audioStream = new MediaStream([track]);
                    audioPlayer.srcObject = audioStream;
                },
                oncleanup: () => {
                    Janus.log("Janus cleanup");
                    // location.reload();
                }
            });
        });
    }

    // Registers SIP connection with Janus server
    registerSip(pluginHandle) {
        let self = this;
        let register = {
            request: "register",
            type: "guest",
            username: "sip:guest@guest.com",
        };

        return new Promise((resolve, reject) => {
            pluginHandle.send({ 
                message: register,
                success: function(result) {
                    resolve(result);
                },
                error: function(error) {
                    reject(error);
                }
            });
        });
    }


    makeAudioCall(pluginHandle, callObject) {
        let self = this;
        return new Promise((resolve, reject) => {
            let sipHost;
            if (callObject.dspEnabled == "true") {
                sipHost = "dsp.together.ly"; //use Solicall
            } else {
                sipHost = "localhost"; //direct to Asterisk
            }
    
            let constraints = {
                audio: { deviceId: { ideal: callObject.audioDeviceId } },
                video: false,
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true,
                voiceIsolation: true,
                googHighpassFilter: true,
            };
    
            let body = {
                request: "call",
                uri: "sip:rtc." + callObject.stasisApp + "." + callObject.conferencePin + "@" + sipHost,
            };
    
            navigator.mediaDevices.getUserMedia(constraints)
                .then((stream) => {
                    const audioTrack = stream.getAudioTracks()[0];
                    if (audioTrack) {
                        audioTrack.applyConstraints({
                            priority: "high",
                        });
                    }
                    pluginHandle.createOffer({
                        tracks: [{ type: "audio", capture: audioTrack, recv: true }],
                        success: function (jsep) {
                            Janus.debug("Got SDP!", jsep);

                            pluginHandle.send({ message: body, jsep: jsep });
                        
                            // Create a timeout promise that rejects after 10 seconds
                            const timeoutPromise = new Promise((_, reject) => {
                                setTimeout(() => {
                                    reject(new Error("Audio call not answered"));
                                }, 10000); 
                            });

                            // Race the timeout promise with the acceptance promise that will be resolved when the audio call accepted message is received by handleMessage
                            Promise.race([
                                new Promise((resolve) => {
                                    self.resolveCallAnswered = resolve;
                                }),
                                timeoutPromise
                            ])
                            .then(resolve)
                            .catch(reject);
                            
                            // Store the reject promise so we can call it from handleMessage
                            self.rejectCallAnswered = reject;
                        
                        },
                        error: function (error) {
                            Janus.error("WebRTC error:", error);
                            reject(error); 
                        },
                    });
                })
                .catch((err) => {
                    reject(err); 
                });
        });
    }


    //creates a promise for the state of the call
    monitorCallState() {
        if (!this.callStatePromise) {
          this.callStatePromise = new Promise((resolve, reject) => {
            this.resolveCallState = (value) => {
              resolve(value);
              this.callStatePromise = null;
              this.resolveCallState = null;
              this.rejectCallState = null;
            };
            this.rejectCallState = (reason) => {
              reject(reason);
              this.callStatePromise = null;
              this.resolveCallState = null;
              this.rejectCallState = null;
            };
          });
        }
        return this.callStatePromise;
      }

    //handle any messages and callbacks from the SIP plugin
    handleMessage(pluginHandle, msg, jsep) {
        let self = this;
        if (msg.result) {
            switch (msg.result.event) {
                case "accepted":
                    console.log("Processing accepted");
                    if (jsep) {
                        pluginHandle.handleRemoteJsep({
                            jsep: jsep,
                            success: () => {
                                Janus.log("Remote SDP accepted!"); //The call is connected at this point
                                // Resolve the promise for makeAudioCall when "accepted" event is received
                                    if (self.resolveCallAnswered ) {
                                        self.resolveCallAnswered();
                                        self.resolveCallAnswered = null;
                                    }
                                },
                            error: (error) => {
                                Janus.error("WebRTC error:", error);
                                if (self.rejectCallAnswered ) {
                                    self.rejectCallAnswered(new Error(error));
                                    self.rejectCallAnswered = null;
                                }
                            },
                        });
                        }
                        break;
                case "registered":
                    //self.stimulate("Webrtc#state","ready");
                    break;
                case "registration_failed":
                    Janus.error("SIP registration failed");
                    if (self.rejectCallAnswered ) {
                        self.rejectCallAnswered(new Error("SIP registration failed"));
                        self.rejectCallAnswered = null;
                    }
                    
                    break;
                case "calling":
                    Janus.log("SIP calling");
                    break;
                case "ringing":
                    Janus.log("SIP ringing");
                    break;
                case "updating":
                    Janus.log("SIP updating");
                    break;
                case "proceeding":
                    Janus.log("SIP proceeding");
                    break;
                case "hangingup":
                    Janus.log("SIP hangingup");
                    
                    break;
                case "hangup":
                
                    //Reject the call answered promise if we receive a hang up
                    if (self.rejectCallAnswered ) {
                        self.rejectCallAnswered(new Error("Call rejected, code: " + msg.result.code));
                        self.rejectCallAnswered = null;
                    }

                    //Resolve the call state promise if we receive a 200 hang up
                    if (self.resolveCallState && msg.result.code == 200) {
                        self.resolveCallState();
                        self.resolveCallState = null;
                    }

                    //Reject the call state promise if we receive a 503
                    if (self.rejectCallState && msg.result.code != 200) {
                        self.rejectCallState(new Error(msg.result.code + " " + msg.result.reason));
                        self.rejectCallState = null;
                    }

                    if(msg.result.code == 503 && dspEnabled == "true") {
                        rollbar.error("Solicall not available, falling back to asterisk");
                        dspEnabled = false;
                        setTimeout(() => {
                            self.makeCall();
                        }, 1000);
                        break;
                    }else{
                        Janus.log("SIP hangup");
                    break;
                }
                default:
                    Janus.error("Unknown SIP event", msg.result.event);

                    break;
                } 
            }   else if (msg.error) {

                Janus.error("SIP message error", msg.error);
        }
    }


}